import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.scss'
import ajaxapi from "./api/api.js";
import $ from 'jquery';
// import axios from 'axios';
import axios from './utils/request.js';
import components from './utils/components.js'  ;
import { clearSignCache } from './router'  // 导入清除签约缓存函数;

Vue.use(ElementUI);
Vue.use(components) //全局注册组件  

const domianOnline ='https://chanyeyanjiu.cn/#/user-login';
const domianLocal = 'http://192.168.1.82:8083/#/user-login';
const domian = process.env.NODE_ENV === 'production' ? domianOnline : domianLocal;
Vue.config.productionTip = false

// 挂载到 Vue 原型
Vue.prototype.$api = ajaxapi;
Vue.prototype.$axios = axios;
Vue.prototype.$ = $
Vue.prototype.jQuery = $

// 挂载到 window
window.$ = $
window.jQuery = $
//退出登录
Vue.prototype.loginOut = function () {
	localStorage.removeItem('userData');
	sessionStorage.removeItem('userData');
	localStorage.removeItem('token');
	sessionStorage.removeItem('token');
	// ✅ 关键：切换账号时清除旧账号的签约缓存
    clearSignCache();
	this.$message.success('退出登录成功');
	setTimeout(() => {
	this.$router.push('/login')
	}, 1000)
},
//加入或取消预选项目
// dataSource 1:政府项目 2:中介服务（产业链上游项目）
Vue.prototype.togglePreselectProject = function (dataSource,list) {
	const _this = this;
	const userData = this.getuseriformation();
	let ajaxurl = this.$api.common.preselectProject.Add();
	let ajaxdata = {
		dataSource: dataSource,
		mergeId: dataSource == 1 ? list.mergeId : list.id ,
	};
	// 取消
	if (list.preselectId>0) {
		ajaxurl = this.$api.common.preselectProject.Cancel();
		ajaxdata = {
			id: list.preselectId
		};
	}
	$.ajax({
		type: "POST",
		url: ajaxurl,
		data: ajaxdata,
		headers: {
			AuthToken:userData.token
		},
		success: function (res) {
			if (res.success) {
				// console.log('togglePreselectProject', res.data.id);
				list.preselectId = list.preselectId>0 ? 0 : res.data.id;
				_this.$message.success(list.preselectId > 0 ? '已取消预选项目' : '已加入预选项目');
			} else {
				_this.$message.error(res.msg);
			}
		}
	});
}
Vue.prototype.toggleProject = function (list) { 
	console.log('toggleProject', list);
	const _this = this;
	const userData = this.getuseriformation();
	let ajaxurl = this.$api.common.project.Add();
	let ajaxdata = {
		preselectId: list.preselectId,
	};
	// 取消
	// if (list.isProject) {
	// 	ajaxurl = this.$api.common.project.Cancel();
	// 	ajaxdata = {
	// 		id: list.id
	// 	};
	// }
	$.ajax({
		type: "POST",
		url: ajaxurl,
		data: ajaxdata,
		headers: {
			AuthToken:userData.token
		},
		success: function (res) {
			if (res.success) {
				// list.preselectId = list.preselectId>0 ? 0 : res.data.id;
				_this.$message.success(list.isProject ? '已取消项目管理' : '已加入项目管理');
			} else {
				_this.$message.error(res.msg);
			}
		}
	});
}
//获取用户信息
Vue.prototype.getuseriformation = function () { 
	let dataddd = localStorage.getItem('userData') ? localStorage.getItem('userData') : sessionStorage.getItem('userData');
	let temData ={};
	if (typeof dataddd  == 'object') {
		 temData = dataddd;
	} else {
		 temData = JSON.parse(dataddd);
	} 
	// console.log(temData,'------');
	if(!temData){
		temData = {
			currentCity: {
				text: ""
			},
			username:'',
			remainDays:'',
			endDate:'',
			operatList: {
				mkczsm: false
			},
			zsdn_version:1,
			groupType:0,
			token: null
		};
	}
	return temData;
}
Vue.prototype.handlerLinkLocal=function(path){  
	let routeUrl = this.$router.resolve({
			path: path, 
	});
	window.open(routeUrl.href, '_blank');  
}
Vue.prototype.routerlinkid=function(path,id,type,code,pagename){ 
	if(!path || path == ''){return;}
	let dataddd=sessionStorage.getItem('userData') ? sessionStorage.getItem('userData'):localStorage.getItem('userData') ;
	var userdatacom={};
	if(typeof(dataddd) == 'object'){
	userdatacom = dataddd;
	}else{
	userdatacom = JSON.parse(dataddd);
	}    
	if(userdatacom.isFree|| (!userdatacom.token && path == '/enterprises')){
		path='/enterprises-free';

	} 
	var pathque={id:id};
	if(type){
		pathque={id:id,type:type?type:'',pagename:pagename?pagename:''};
	} 
	let token = btoa(userdatacom.token);
	let queryString =  btoa(path+'?' + Object.keys(pathque).map(key => `${key}=${pathque[key]}`).join('&'));
	window.open(domian+'?token='+token+'&refer='+queryString, '_blank');  
}
//新页面打开
Vue.prototype.routerblank=function(path){  
	let userData = this.getuseriformation();
	if(!path || path == ''){return;}
	let token = btoa(userData.token);
	let queryString = btoa(path);
	window.open(domian+'?token='+token+'&refer='+queryString, '_blank');  
}

//当前页打开
Vue.prototype.routerself=function(path){  
	let routeUrl = this.$router.resolve({
			path: path, 
	});
	window.open(routeUrl.href, '_self');  
}

//数组字符串拼接
Vue.prototype.datajoin=function(name, data) { 
	var ddd='';
	if(data.length>0){
		ddd='&'+name+'='+data.join('%2C');
	}
	return ddd;
} 
Vue.prototype.taglistfun=function(ac,bc,style){
	let arrys=[];
	if(ac == ""){
		return arrys;
	}
	let dd=ac.split(',');
	let de=bc.split(',');  
	for(var i=0;i<dd.length;i++){
		arrys.push({name:dd[i],id:de[i]}); 
	}  
	if(style == 'notionsort'){
		let arry1=arrys.filter((list=>{
			return list.id.indexOf('A')===0;
		}))
		let arry2=arrys.filter((list=>{
			return list.id.indexOf('A')!=0;
		}))
		
		arrys=arry1.concat(arry2);
	} 
	return arrys; 
}
//验证是否为空参数
Vue.prototype.splicing = function (name, value, isFirst) {
  var url1 = '';
  let symbol = isFirst ? "?" : "&";
  if (value != '' && value != null && value != 0 && value != 'all') {
    url1 = symbol + name + '=' + value;
  }
  return url1;
},
//列表收藏和详情页收藏 type == acoc 代表是传list.id 不传为list.stockCode
Vue.prototype.listToggleCollect=function(list,type){
	console.log('listToggleCollect',list);
	 var _this=this,cid=list.collectId;
	 var ajaxurl="",ajaxdata={},msgtext="",msgtype="";
		var cids=type == 'acoc'?list.id:list.stockCode;
	 if(cid == 0){
	  ajaxurl=this.$api.cyl.collect.add();
	 	ajaxdata={type:list.collectType,id:cids}
	 	}else{
	 		ajaxurl=this.$api.cyl.collect.remove();
	 		ajaxdata={collectId:list.collectId};
	 	} 
	 	$.ajax({
	 		type:"POST",
	 		url:ajaxurl,
	 		data:ajaxdata,
	 		headers:{AuthToken:this.userdata.token },
	 		success:function(res){ 
	 			// console.log('1123',list.collectId,res,list.stockCode);
	 			if(res.success){
	 				if(cid == 0){
	 					list.collectId=res.data.collectId;
							msgtext="已加入目标企业";
	 				}else{
	 					list.collectId=0;
							msgtext="已移除目标企业";
	 				}  
						msgtype="success";
	 			}else{
						msgtype="error";
						msgtext=res.msg;
					} 
					_this.$message({
						type: msgtype,
						message: msgtext,
					});
	 		} 
	 	})   
}
Vue.prototype.tagrouter=function(path,pagetype,type,id,name,pagename){ 
	let routeUrl = this.$router.resolve({
		path: path,query: {type:pagetype,key:type,id:id,keyword:name,pagename:pagename}
});
	window.open(routeUrl.href, '_blank');  
}

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
